import { DynamicObjectInterface, updateApiErrorData } from '@commerce-profile-webcomponents/sdk';
import { useDispatch } from 'react-redux';
import { Logger } from '@nextgen-web-framework/core';

interface ErrorResponse {
  responseBody?: DynamicObjectInterface;
  message?: string;
  status?: number;
}

const useGlobalErrorHandler = () => {
  const dispatch = useDispatch();
  const loggerService = Logger.getInstance();
  const executeApi = async <TResponse>(apiCallback: () => Promise<TResponse>): Promise<TResponse> => {
    try {
      const response = await apiCallback();
      loggerService.log(response, 'API response');
      return response;
    } catch (error) {
      loggerService.log(error);
      const errData = (error as ErrorResponse)?.responseBody ?? (error as ErrorResponse)?.message;
      if (errData?.status >= 400 && errData?.status < 500) {
        throw error;
      }
      dispatch?.(updateApiErrorData({ message: errData }));
      return Promise.resolve(undefined as TResponse);
    }
  };

  return executeApi;
};

export { useGlobalErrorHandler };
